/**
 * WithdrawalService — wrapper compatível com a UI legada.
 * Agora consome /api/v2/withdrawals + /api/v2/balances.
 *
 * - Saldo / configuração de antecipação agora vem do BalanceServiceV2 (única fonte)
 * - Filtros por status (pending/approved/rejected) agora viram query ?status=
 * - processBalances removido: era código morto no V1 (nunca chamado pela UI)
 */

import { withdrawalsV2API, balancesV2API } from './v2/withdrawals';

export const WithdrawalService = {
  /**
   * Saldo do owner (disponível + pendente + antecipado).
   * V2 BalanceServiceV2 é a fonte única.
   */
  getBalance: async () => {
    const res = await balancesV2API.me();
    return res.data;
  },

  /**
   * Configurações de antecipação do user (release days, mínimo saque, %).
   */
  getAdvanceSettings: async () => {
    const res = await balancesV2API.myConfig();
    return res.data;
  },

  /**
   * Solicita saque. Body: { amount_cents, bank_account_id, user_notes? }
   */
  createRequest: async (requestData) => {
    const res = await withdrawalsV2API.request(requestData);
    return res.data;
  },

  /**
   * Solicitações do user.
   */
  getUserRequests: async (filters = {}) => {
    const params = {};
    if (filters.status) params.status = filters.status;
    const res = await withdrawalsV2API.listMine(params);
    return res.data;
  },

  /**
   * Admin: solicitações pendentes (filtro status=pending).
   */
  getPendingRequests: async () => {
    const res = await withdrawalsV2API.listAll({ status: 'pending' });
    return res.data;
  },

  /**
   * Admin: solicitações aprovadas (Extrato).
   */
  getApprovedRequests: async () => {
    const res = await withdrawalsV2API.listAll({ status: 'approved' });
    return res.data;
  },

  /**
   * Admin: solicitações rejeitadas.
   */
  getRejectedRequests: async () => {
    const res = await withdrawalsV2API.listAll({ status: 'rejected' });
    return res.data;
  },

  /**
   * Admin: aprovar.
   */
  approveRequest: async (requestId, adminNotes = '') => {
    const res = await withdrawalsV2API.approve(requestId, { admin_notes: adminNotes });
    return res.data;
  },

  /**
   * Admin: rejeitar.
   */
  rejectRequest: async (requestId, rejectionReason) => {
    const res = await withdrawalsV2API.reject(requestId, { reason: rejectionReason });
    return res.data;
  },

  /**
   * Admin: detalhes da solicitação.
   */
  getRequestDetails: async (requestId) => {
    const res = await withdrawalsV2API.findById(requestId);
    return res.data;
  },
};

export default WithdrawalService;
